import React from 'react';
import ReactModal from 'react-modal';

import { DSelect, HookForm } from '../../../../validation/HForm';
import { searchClientSchema } from '../../../../validation/scheme/quickCalculationSchema';
import { Message } from '../../../utilites';

import './search-client-modal.scss';

import AddClientIcon from '../../../../assets/icons/add-client.svg';
import { getClients } from '../../../../redux/actions/clientsAction';
import { useDispatch, useSelector } from 'react-redux';

const SearchClientModal = ({ isOpen, handleModalSubmit, handleCloseModal, addNewClient }) => {
  const { clients, loading, commonError } = useSelector(({ clients }) => clients);

  const searchClients = clients.map((i) => ({
    value: i?.id,
    label: `${i?.fullName} ${i?.personal}`,
  }));
  const dispatch = useDispatch();

  const handleOptionsClient = (val, action) => {
    if (action.action === 'input-change') {
      dispatch(
        getClients({
          size: 5,
          page: 1,
          sortBy: 'fullName',
          name: val,
          filters: {
            active: true,
          },
        }),
      );
    }
  };

  return (
    <ReactModal
      isOpen={isOpen}
      contentLabel="Modal"
      className="modal-container"
      overlayClassName="modal-overlay">
      <HookForm onSubmit={handleModalSubmit} validationSchema={searchClientSchema}>
        <div className="modal-header search-modal-header">
          <h2>Поиск существующего клиента</h2>
        </div>
        <div className="modal-body search-modal-body">
          <div className="form-element">
            <div className="content-datatable-header-right">
              <div className="action-items">
                <button
                  className="button-icontrigger-accent caption hover"
                  type="button"
                  onClick={addNewClient}>
                  <span className="icon">
                    <AddClientIcon />
                  </span>
                  <span>Добавить клиента</span>
                </button>
              </div>
            </div>
          </div>
          {commonError && <Message type="error" text={commonError} />}
          <div className="form-element">
            <div className="form-element-data combobox searchClientModal">
              <DSelect
                h="true"
                name="existingClient"
                isLoading={loading}
                options={searchClients}
                defaultValue={null}
                handleOptions={handleOptionsClient}
                placeholder="Введите имя"
              />
            </div>
          </div>
        </div>
        <div className="modal-footer">
          <button className="button">Сохранить</button>
          <button className="button-light" type="button" onClick={handleCloseModal}>
            Отменить
          </button>
        </div>
      </HookForm>
    </ReactModal>
  );
};

export default SearchClientModal;
